// extracted by mini-css-extract-plugin
export default {"page404":"index_page404__Mdam6"};